import { Excess } from '../types';

export const SHOW_MORE_TYPE = 'showMore';

export const SHOW_MORE_OPTION = {
  id: '',
  type: SHOW_MORE_TYPE,
  amount: 0,
};

type ExpandableOption = {
  label: string;
  value: number | Excess;
};

/*
 * Should be passed the final list of (label, value) pairs
 */
export const filterOptionsToDisplay = (
  options: Array<ExpandableOption>,
  showMoreOption: ExpandableOption,
  numBeforeShowMore: number,
  selectedOption: ExpandableOption | undefined,
  showMoreOnSelect?: boolean
): Array<ExpandableOption> => {
  let index = -1;

  if (selectedOption) {
    index = options.findIndex(
      (option) => option.label === selectedOption.label
    );
  }

  if (index < numBeforeShowMore) {
    return options.slice(0, numBeforeShowMore).concat(showMoreOption);
  }
  // When a value from 'more options' is selected an the user returns to
  // the question, should an abbreviated list with show more button appear or
  // alternatively should all options appear?
  if (showMoreOnSelect) {
    return options
      .slice(index - (numBeforeShowMore - 1), index + 1)
      .concat(showMoreOption);
  }
  return options;
};
